// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__AVdIH","amount":"Amount_amount__2j6AS","tip":"Amount_tip__1oq0j","tipHeader":"Amount_tipHeader___y4Ll","tipsWrap":"Amount_tipsWrap__3sKfS"};